import { getImageUrl } from '@wix/communities-forum-client-commons';
const FB_MIN_THUMBNAIL_SIZE = 200;
export const getImageMetadataFromWixMedia = (image) => ({
    src: image.file_name ? getImageUrl(image) : null,
    height: image.height || null,
    width: image.width || null,
});
export const getVideoThumbnailMetadata = (videoMetadata) => {
    var _a, _b, _c, _d, _e, _f;
    return isVimeo(videoMetadata)
        ? getVimeoThumbnailMetadata(videoMetadata)
        : {
            src: (_a = videoMetadata.thumbnail_url) !== null && _a !== void 0 ? _a : null,
            height: (_c = (_b = videoMetadata.height) !== null && _b !== void 0 ? _b : videoMetadata.thumbnail_height) !== null && _c !== void 0 ? _c : null,
            width: (_e = (_d = videoMetadata.width) !== null && _d !== void 0 ? _d : videoMetadata.thumbnail_width) !== null && _e !== void 0 ? _e : null,
            videoUrl: (_f = videoMetadata.video_url) !== null && _f !== void 0 ? _f : null,
        };
};
const isVimeo = (metadata) => (metadata.provider_name || '').toLowerCase() === 'vimeo';
const getVimeoThumbnailMetadata = (metadata) => {
    var _a;
    const { thumbnail_width: width, thumbnail_height: height } = metadata;
    const adjustedWidth = Math.max(width, FB_MIN_THUMBNAIL_SIZE);
    const adjustedHeight = Math.max(height, FB_MIN_THUMBNAIL_SIZE);
    const re = new RegExp(`${width}x${height}`);
    const src = (metadata.thumbnail_url || '').replace(re, `${adjustedWidth}x${adjustedHeight}`);
    return {
        src,
        height: adjustedHeight,
        width: adjustedWidth,
        videoUrl: (_a = metadata.video_url) !== null && _a !== void 0 ? _a : null,
    };
};
//# sourceMappingURL=cover-image-utils.js.map